import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import SobreMi from "@/pages/SobreMi";
import TecnicaNagi from "@/pages/TecnicaNagi";
import Academia from "@/pages/Academia";
import Servicios from "@/pages/Servicios";
import Studio from "@/pages/Studio";
import Tienda from "@/pages/Tienda";
import Contacto from "@/pages/Contacto";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

const ScrollManager = () => {
  const { pathname } = useLocation();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="grain bg-cream min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-mi" element={<SobreMi />} />
            <Route path="/tecnica-nagi" element={<TecnicaNagi />} />
            <Route path="/academia" element={<Academia />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/mi-studio" element={<Studio />} />
            <Route path="/tienda" element={<Tienda />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/aviso-legal" element={<Legal type="aviso" />} />
            <Route path="/privacidad" element={<Legal type="privacidad" />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#0A0A0A", color: "#FDFBF7", border: "1px solid rgba(197,160,89,0.4)" } }} />
      </BrowserRouter>
    </div>
  );
}

export default App;
